// @flow
import i18n from 'i18n-js';

export const DEFAULT_ERROR = () => i18n.t('temporalBanners.defaultError');
export const FETCH_ERROR = (Item: string) => i18n.t('temporalBanners.fetchError', { Item });
export const UPDATE_ERROR = (Item: string) => i18n.t('temporalBanners.updateError', { Item });
export const CREATE_ERROR = (Item: string) => i18n.t('temporalBanners.createError', { Item });
export const REMOVE_ERROR = (Item: string) => i18n.t('temporalBanners.removeError', { Item });
export const ADD_ERROR = (Item: string) => i18n.t('temporalBanners.addError', { Item });
export const UNASIGN_ERROR = (Item: string) => i18n.t('temporalBanners.unasignError', { Item });
export const DEFAULT_UPDATE = (Item: string) => i18n.t('temporalBanners.update', { Item });
export const DEFAULT_CREATE = (Item: string) => i18n.t('temporalBanners.create', { Item });
export const DEFAULT_REMOVE = (Item: string) => i18n.t('temporalBanners.remove', { Item });
export const DEFAULT_ADD = (Item: string) => i18n.t('temporalBanners.add', { Item });
export const DEFAULT_UNASIGN = (Item: string) => i18n.t('temporalBanners.unasign', { Item });
export const DEFAULT_DURATION = 2000;



// WEBPACK FOOTER //
// ./src/scripts/utils/errorDefaults.js